import axios from 'axios';

import React, { useEffect, useState } from 'react';
import { useAuth } from "../../contexts/AuthContext";
import {
  Row,
  Col,
  Card,
  Button,
  Form,
  Table,
  Badge,
  Modal
} from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash, FaLock, FaTimes, FaLink } from 'react-icons/fa';


const DPDPInventoryTab = ({userData, onScoreUpdate,logToAccessLogs }) => {
  const [modalType, setModalType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [dataInventory, setDataInventory] = useState([]);
  const { profile } = useAuth();
   const organizationId = profile?.orgId;
  //    const organizationId = profile?.orgId;
  const [formData, setFormData] = useState({
    dataType: '',
    processingActivityName: '',
    classification: '',
    
    owner: '',
    dataSubjectCategory: '',
processorThirdParty: '',
    purpose: '',
    retention: '',
    location: '',
    encryptedAtRest: false,
    encryptedInTransit: false,
    roleBasedAccess: false,
    // NEW MANDATORY FIELDS
    processingPurposeLink: '',
    consentReference: '',
    retentionRuleLink: ''
  });

  const getUserRegion = () => sessionStorage.getItem('userRegion') || 'AP';

  const logActivity = async (message, badge = "info") => {
    try {
       await axios.post(
             "https://ugat9qq1mj.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/activities/create",
             {
               message,
               badge,
               timestamp: new Date().toISOString()
             },
             {
               headers: {
                 Region: getUserRegion(),
                 organizationId: organizationId
               }
          });
         } catch (err) {
      console.warn("Failed to log activity:", err.message);
    }
  };

  const UserData = organizationId;
  const [editId, setEditId] = useState(null);
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });

  const showToast = (message, variant = 'success') => {
    setToast({ show: true, message, variant });
  };

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => setToast({ ...toast, show: false }), 3000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  const openModal = (type, item = null) => {
    setModalType(type);
    setShowModal(true);

    if (type === 'edit' && item) {
      setEditId(item.id);
      setFormData({
        dataType: item.dataType || '',
        processingActivityName: item.processingActivityName || '',
        classification: item.classification || '',
      owner: item.owner || '',
dataSubjectCategory: item.dataSubjectCategory || '',
processorThirdParty: item.processorThirdParty || '',
purpose: item.purpose || '',
        retention: item.retention || '',
        location: item.location || '',
        encryptedAtRest: item.encryptedAtRest || false,
        encryptedInTransit: item.encryptedInTransit || false,
        roleBasedAccess: item.roleBasedAccess || false,
        processingPurposeLink: item.processingPurposeLink || '',
        consentReference: item.consentReference || '',
        retentionRuleLink: item.retentionRuleLink || ''
      });
    } else {
      setEditId(null);
      setFormData({
        dataType: '',
        processingActivityName: '',
        classification: '',
       owner: '',
dataSubjectCategory: '',
processorThirdParty: '',
purpose: '',
        retention: '',
        location: '',
        encryptedAtRest: false,
        encryptedInTransit: false,
        roleBasedAccess: false,
        processingPurposeLink: '',
        consentReference: '',
        retentionRuleLink: ''
      });
    }
  };

  const closeModal = () => {
    setModalType(null);
    setShowModal(false);
    setEditId(null);
    setFormData({
      dataType: '',
      processingActivityName: '',
      classification: '',
     owner: '',
dataSubjectCategory: '',
processorThirdParty: '',
purpose: '',
      retention: '',
      location: '',
      encryptedAtRest: false,
      encryptedInTransit: false,
      roleBasedAccess: false,
      processingPurposeLink: '',
      consentReference: '',
      retentionRuleLink: ''
    });
  };

  // const fetchData = async () => {
  //   try {
  //     const res = await axios.get("https://vkvnrh2vze.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/inventory/list", {
  //       headers: {
  //         Region: getUserRegion(),
  //         organizationId: organizationId
  //       }
  //     });
  //     setDataInventory(res.data);
  //   } catch (err) {
  //     console.error("Error fetching inventory:", err);
  //   }
  // };
/****new cross region fetchData */
// Replace ONLY this function â€” nothing else changes
const fetchData = async () => {
  try {
    const res = await axios.get(
      "https://vkvnrh2vze.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/inventory/list",
      {
        headers: {
          Region: getUserRegion(),   // backend uses as primary hint, scans all regions
          organizationId: organizationId
        }
      }
    );
    // Backend already merged + deduped + sorted all regions
    setDataInventory(res.data);
  } catch (err) {
    console.error("Error fetching inventory:", err);
  }
};
  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async () => {
    // Validate mandatory fields
    if (
  !formData.dataType ||
  !formData.processingActivityName ||
  !formData.classification ||
  !formData.owner ||
  !formData.dataSubjectCategory ||
  !formData.processorThirdParty ||
  !formData.purpose ||
  !formData.retention ||
  !formData.location ||
  !formData.processingPurposeLink ||
  !formData.consentReference ||
  !formData.retentionRuleLink
) {
  showToast('Please fill all mandatory DPDP inventory fields', 'danger');
  return;
}

    const url = editId
      ? `https://v2td7zpg8c.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/inventory/update/${editId}`
      : `https://3ea4yrmjv1.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/inventory/create`;
    const method = editId ? 'put' : 'post';

    try {
      await axios[method](url, formData, {
        headers: {
          Region: getUserRegion(),
            organizationId: organizationId
        }
      });

      await logActivity(
        editId
          ? `Updated data asset: ${formData.dataType}`
          : `Added new data asset: ${formData.dataType}`,
        editId ? "primary" : "success"
      );
      logToAccessLogs?.({
  action:      editId ? 'Data Asset Updated' : 'Data Asset Created',
  severity:    editId ? 'warning' : 'success',
  description: `${editId ? 'Updated' : 'Created'} data asset: ${formData.dataType} (${formData.classification})`,
      });

      showToast(`Data asset ${editId ? 'updated' : 'created'} successfully`, 'success');
      closeModal();
      fetchData();
    } catch (err) {
      console.error(`${editId ? 'Update' : 'Save'} failed:`, err);
      showToast('Failed to save data asset', 'danger');
    }
  };

  // UPDATED CLASSIFICATIONS - DPDP Act 2023 Compliant
  const CLASS = {
    PERSONAL: "Personal Data",
    CHILDREN: "Children's Personal Data",
    NON_PERSONAL: "Non-Personal Data"
  };

  const personalCount = dataInventory.filter(i => i.classification === CLASS.PERSONAL).length;
  const childrenCount = dataInventory.filter(i => i.classification === CLASS.CHILDREN).length;
  const nonPersonalCount = dataInventory.filter(i => i.classification === CLASS.NON_PERSONAL).length;

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this entry?")) return;

    try {
      await axios.delete(`https://x7mwbfm9q5.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/inventory/delete/${id}`, {
        headers: {
          Region: getUserRegion(),
            organizationId: organizationId
        }
      });

      await logActivity(`Deleted data asset with ID: ${id}`, "danger");
      logToAccessLogs?.({
  action:      'Data Asset Deleted',
  severity:    'critical',
  description: `Deleted data asset with ID: ${id}`,
      });
      showToast('Data asset deleted successfully', 'success');
      fetchData();
    } catch (err) {
      console.error("Delete failed:", err);
      showToast('Failed to delete data asset', 'danger');
    }
  };

  useEffect(() => {
    if (onScoreUpdate) {
      if (dataInventory.length === 0) {
        onScoreUpdate(0);
        return;
      }

      // Updated weights for new classifications
      const CLASS_WEIGHT = {
        "Children's Personal Data": 3,  // Highest priority
        "Personal Data": 2,
        "Non-Personal Data": 1,
        '': 0
      };

      // Updated required fields including new mandatory ones
      const REQUIRED_FIELDS = [
        'dataType',
        'processingActivityName',
        'classification',
        'owner',
'dataSubjectCategory',
'processorThirdParty',
'purpose',
        'retention',
        'location',
        'processingPurposeLink',
        'consentReference',
        'retentionRuleLink'
      ];

      let totalPossible = 0;
      let totalEarned = 0;

      dataInventory.forEach(item => {
        const classificationWeight = CLASS_WEIGHT[item.classification] || 0;
        if (classificationWeight === 0) return;

        const maxAssetPoints = (REQUIRED_FIELDS.length + 3) * classificationWeight;
        totalPossible += maxAssetPoints;

        let assetScore = 0;
        REQUIRED_FIELDS.forEach(field => {
          if (item[field] && item[field].toString().trim() !== '') {
            assetScore += classificationWeight;
          }
        });

        const toBool = (v) => v === true || v === 'true' || v === 1;
        assetScore += toBool(item.encryptedAtRest) ? classificationWeight : 0;
        assetScore += toBool(item.encryptedInTransit) ? classificationWeight : 0;
        assetScore += toBool(item.roleBasedAccess) ? classificationWeight : 0;

        totalEarned += assetScore;
      });

      const normalizedScore = totalPossible > 0
        ? Math.round((totalEarned / totalPossible) * 100)
        : 0;

      onScoreUpdate(normalizedScore);
    }
  }, [dataInventory]);

  return (
    <>
      {/* Toast Notification */}
      {toast.show && (
        <div className={`alert alert-${toast.variant} position-fixed top-0 end-0 m-3`} style={{ zIndex: 9999 }}>
          {toast.message}
        </div>
      )}

      <Card className="mb-4 mt-3">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Data Asset Register (DPDP Act 2023)</h5>
          <Button variant="primary" className='NewTransfer' size="sm" onClick={() => openModal("inventory")}>
            <FaPlus className="me-1" />
            Add Data Asset
          </Button>
        </Card.Header>
        <Card.Body>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead className="table-dark">
                <tr>
                  <th>Data Type</th>
                  <th>Classification</th>
                  <th>Owner</th>
<th>Data Subjects</th>
<th>Processor / Third Party</th>
<th>Purpose</th>
                  <th>Retention</th>
                  <th>Location</th>
                  <th>Compliance Links</th>
                  <th>Encrypted</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {dataInventory.map((item) => (
                  <tr key={item.id}>
                    <td>{item.dataType}</td>
                    <td>
                      <Badge bg={
                        item.classification === CLASS.CHILDREN ? 'danger' :
                        item.classification === CLASS.PERSONAL ? 'primary' :
                        item.classification === CLASS.NON_PERSONAL ? 'secondary' :
                        'secondary'
                      }>
                        {item.classification}
                      </Badge>
                    </td>
                   <td>{item.owner}</td>
<td>{item.dataSubjectCategory || '-'}</td>
<td>{item.processorThirdParty || '-'}</td>
<td>{item.purpose}</td>
                    <td>{item.retention}</td>
                    <td>{item.location}</td>
                    <td>
                      <div className="d-flex flex-column gap-1">
                        {item.processingPurposeLink && (
                          <a href={item.processingPurposeLink} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                            <small><FaLink /> Purpose</small>
                          </a>
                        )}
                        {item.consentReference && (
                          <small title="Consent Reference"><FaLink /> {item.consentReference}</small>
                        )}
                        {item.retentionRuleLink && (
                          <a href={item.retentionRuleLink} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                            <small><FaLink /> Retention</small>
                          </a>
                        )}
                      </div>
                    </td>
                    <td>
                      <div>
                        <small title="Encrypted at Rest">
                          At Rest: {item.encryptedAtRest ? <FaLock className="text-success" /> : <FaTimes className="text-danger" />}
                        </small><br />
                        <small title="Encrypted in Transit">
                          In Transit: {item.encryptedInTransit ? <FaLock className="text-success" /> : <FaTimes className="text-danger" />}
                        </small>
                      </div>
                    </td>
                    <td>
                      <Button variant="outline-primary" size="sm" className="me-1" onClick={() => openModal('edit', item)}>
                        <FaEdit />
                      </Button>
                      <Button variant="outline-danger" size="sm" onClick={() => handleDelete(item.id)}>
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* Updated Summary Cards */}
      <Row className="mb-4">
        <Col md={4}>
          <Card className="text-center border-primary">
            <Card.Body>
              <h4 className="text-primary">{personalCount}</h4>
              <p className="mb-0">Personal Data Assets</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center border-danger">
            <Card.Body>
              <h4 className="text-danger">{childrenCount}</h4>
              <p className="mb-0">Children's Personal Data</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center border-secondary">
            <Card.Body>
              <h4 className="text-secondary">{nonPersonalCount}</h4>
              <p className="mb-0">Non-Personal Data</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Updated Modal Form */}
      <Modal show={showModal} onHide={closeModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{editId ? 'Edit' : 'Add'} Data Asset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(modalType === 'inventory' || modalType === 'edit') && (
            <Form>

              <Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>
        Processing Activity Name <span className="text-danger">*</span>
      </Form.Label>
      <Form.Control
        type="text"
        value={formData.processingActivityName}
        onChange={(e) =>
          setFormData({ ...formData, processingActivityName: e.target.value })
        }
        placeholder="e.g., Customer Onboarding, Payroll Processing"
      />
    </Form.Group>
  </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Data Type <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.dataType}
                      onChange={(e) => setFormData({ ...formData, dataType: e.target.value })}
                      placeholder="e.g., Customer Email Addresses"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Classification <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      value={formData.classification}
                      onChange={(e) => setFormData({ ...formData, classification: e.target.value })}
                    >
                      <option value="">-- Select Classification --</option>
                      <option value="Personal Data">Personal Data</option>
                      <option value="Children's Personal Data">Children's Personal Data</option>
                      <option value="Non-Personal Data">Non-Personal Data</option>
                    </Form.Select>
                    <Form.Text className="text-muted">
                      As per DPDP Act 2023
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Data Owner <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.owner}
                      onChange={(e) => setFormData({ ...formData, owner: e.target.value })}
                      placeholder="Department or person responsible"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Storage Location <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      value={formData.location}
                      onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                    >
                      <option value="">-- Select Location --</option>
                      <option value="India - Primary DC">India - Primary DC</option>
                      <option value="India - Secondary DC">India - Secondary DC</option>
                      <option value="Cloud - India Region">Cloud - India Region</option>
                      <option value="On-Premises">On-Premises</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
<Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Data Subject Category <span className="text-danger">*</span></Form.Label>
      <Form.Select
        value={formData.dataSubjectCategory}
        onChange={(e) => setFormData({ ...formData, dataSubjectCategory: e.target.value })}
      >
        <option value="">-- Select Data Subject --</option>
        <option value="Customers">Customers</option>
        <option value="Employees">Employees</option>
        <option value="Children">Children</option>
        <option value="Vendors">Vendors</option>
        <option value="Website Visitors">Website Visitors</option>
        <option value="Partners">Partners</option>
      </Form.Select>
    </Form.Group>
  </Col>

  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Processor / Third Party <span className="text-danger">*</span></Form.Label>
      <Form.Control
        type="text"
        placeholder="Example: Internal Only, AWS, Salesforce, Zendesk"
        value={formData.processorThirdParty}
        onChange={(e) => setFormData({ ...formData, processorThirdParty: e.target.value })}
      />
    </Form.Group>
  </Col>
</Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Retention Period <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g., 3 years"
                      value={formData.retention}
                      onChange={(e) => setFormData({ ...formData, retention: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Processing Purpose <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Primary business purpose"
                      value={formData.purpose}
                      onChange={(e) => setFormData({ ...formData, purpose: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* NEW MANDATORY FIELDS */}
              <hr />
              <h6>Compliance Links (Mandatory)</h6>
              
              <Form.Group className="mb-3">
                <Form.Label>Processing Purpose Link <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="url"
                  placeholder="https://company.com/processing-purposes/customer-support"
                  value={formData.processingPurposeLink}
                  onChange={(e) => setFormData({ ...formData, processingPurposeLink: e.target.value })}
                />
                <Form.Text className="text-muted">
                  Link to documented processing purpose
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Consent Reference <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g., CONSENT-2024-001 or N/A for legitimate interest"
                  value={formData.consentReference}
                  onChange={(e) => setFormData({ ...formData, consentReference: e.target.value })}
                />
                <Form.Text className="text-muted">
                  Consent ID or basis for processing
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Retention Rule Link <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="url"
                  placeholder="https://company.com/retention-policies/customer-data"
                  value={formData.retentionRuleLink}
                  onChange={(e) => setFormData({ ...formData, retentionRuleLink: e.target.value })}
                />
                <Form.Text className="text-muted">
                  Link to retention policy document
                </Form.Text>
              </Form.Group>

              <hr />
              <h6>Security Controls</h6>
              
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Data is encrypted at rest"
                  checked={formData.encryptedAtRest}
                  onChange={(e) => setFormData({ ...formData, encryptedAtRest: e.target.checked })}
                />
                <Form.Check
                  type="checkbox"
                  label="Data is encrypted in transit"
                  checked={formData.encryptedInTransit}
                  onChange={(e) => setFormData({ ...formData, encryptedInTransit: e.target.checked })}
                />
                <Form.Check
                  type="checkbox"
                  label="Access is role-based and logged"
                  checked={formData.roleBasedAccess}
                  onChange={(e) => setFormData({ ...formData, roleBasedAccess: e.target.checked })}
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>Cancel</Button>
          <Button variant="primary" onClick={handleSave}>
            {editId ? 'Update' : 'Save'} Data Asset
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DPDPInventoryTab;